import React from 'react'
import Container from '@mui/material/Container';

const Footer = () => {
    return (
        <div className='footer-section'>
            <Container>
                <p><strong>DrivePlus Inc&copy; 2023</strong></p>
            </Container>
        </div>
    )
}

export default Footer